import { FC, useMemo } from 'react'
import { useTranslation } from 'next-i18next/pages'
import { FieldErrors, UseFormRegister } from 'react-hook-form'
import { GiftCardProduct } from '@pylot-data/pylotschema'
import { formatCurrency } from '@lib/utils/formatCurrency'
import type { GiftCardProductInputArgs } from './GiftCardProduct'
import cn from 'classnames'
import s from './AmountDropdown.module.scss'

export type Props = {
    register: UseFormRegister<GiftCardProductInputArgs>
    product: GiftCardProduct
    errors: FieldErrors<GiftCardProductInputArgs>
}

export enum OtherAmountEnum {
    Other = 'other'
}

export const AmountDropdown: FC<Props> = ({ register, product, errors }) => {
    const { t } = useTranslation(['pdp'])
    const { allow_open_amount, giftcard_amounts } = product
    const rootClassName = cn(
        s.select,
        'appearance-none border-b border-p-7 py-2 px-0 mb-2 focus:shadow-none focus:outline-none focus-visible:border-b focus-visible:shadow-none truncate overflow-hidden pr-8'
    )

    const amountOptions = useMemo(() => {
        return giftcard_amounts?.map((amount, key) => (
            <option key={key} value={amount?.uid}>
                {formatCurrency(amount?.value || 0)}
            </option>
        ))
    }, [giftcard_amounts])

    if (!giftcard_amounts?.length) return null

    return (
        <div>
            <div>
                <select
                    id="gift_amounts"
                    className={rootClassName}
                    defaultValue={
                        allow_open_amount ? OtherAmountEnum.Other : ''
                    }
                    {...register('gift_amounts', { required: true })}
                >
                    <option value="">
                        {t('Selecciona el monto de tu Gift Card')}
                    </option>
                    {amountOptions}
                    {allow_open_amount && (
                        <option value={OtherAmountEnum.Other}>
                            {t('pdp||giftCard|Other Amount...')}
                        </option>
                    )}
                </select>
            </div>
            {errors.gift_amounts && (
                <span className="error">{t('Este campo es obligatorio')}</span>
            )}
        </div>
    )
}
